import React from 'react';
import {Map} from 'immutable';
import {
  iconName,
  qualify,
  pluginName,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {
  withSystem,
  Plugins,
  Atom,
  AtomRenderProps,
} from '@packages/systems/wfdl';
import {
  TListOfElement,
  TTypeConstructor,
  TRecord,
  TText,
} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {
  EvaluatedNodeData,
  getChildren,
  getInPojo,
  getRecord,
  getTag,
} from '@packages/utilities/data-utils';

const Row = Atom.createRender(
  ({
    attributes,
    classes,
    data,
    generateAttributes,
    renderChild,
    context,
  }: AtomRenderProps) => {
    // If there is data in `temp` it gets more priority
    const persistedCols = getRecord(getInPojo(data, ['grid', 'cols']));
    const tempCols = getRecord(getInPojo(data, ['temp', 'grid', 'cols']));
    const colsData = persistedCols || tempCols ? {...persistedCols} : undefined;
    if (colsData && tempCols) {
      for (const [breakpoint, width] of Object.entries(tempCols)) {
        if (width) colsData[breakpoint] = width;
      }
    }
    const updatedContext = context.set(
      'widths',
      colsData ? Map(colsData) : undefined
    );
    const rowClasses = classes.push('w-row');
    const Tag = getTag(getInPojo(data, ['tag'])) as React.ElementType;
    return (
      <Tag {...generateAttributes(attributes, rowClasses)}>
        {getChildren(data).map((child: EvaluatedNodeData, index: number) =>
          renderChild(child, updatedContext.set('columnIndex', index))
        )}
      </Tag>
    );
  }
);

const config = createDevlinkAtom({
  render: Row,
  displayName: 'Columns',
  showEmpty: true,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Layout'), iconName('Row')),
  },
  constraints: {
    children: [
      {
        is: 'Column',
        name: 'Non-Column Item',
        rule: 'RequireOnly',
      },
    ],
  },
  fields: {
    grid: withSystem(
      {private: true},
      TRecord({
        type: TText,
        cols: TRecord({
          main: TText,
          medium: TText,
          small: TText,
          tiny: TText,
        }),
      })
    ),
    temp: withSystem(
      {private: true},
      TRecord({
        grid: TRecord({
          cols: TRecord({
            main: TText,
            medium: TText,
            small: TText,
            tiny: TText,
          }),
        }),
      })
    ),
    tag: withSystem(
      {
        label: 'Tag',
        private: true,
        defaultValue: 'div',
        isLocalizable: true,
      },
      TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
    ),
    children: TListOfElement,
  },
});

export default config;
